<template>
    <div id="app">
        <v-app id="inspire">
            <v-content>
                <v-alert style="background-color:silver" v-if="isSuccess">ログイン成功</v-alert>
                <v-alert style="background-color:silver" v-if="isError">ログイン失敗...</v-alert>
                <v-container fluid
                             fill-height>
                    <v-layout align-center
                              justify-center
                              >

                        <div class="title-container">
                            <div align="center" class="my-9" style="color:gray">
                                <h2>{{ info }}</h2>
                            </div>
                            <div align="center" class="my-9" style="color:grey">
                                <span>Ver - {{ version }}</span>
                            </div>
                            <v-card-text>
                                <v-form>
                                    <v-text-field label="ID"
                                                  name="login"
                                                  type="text"
                                                  v-model="params.name"
                                                  solo></v-text-field>

                                    <v-text-field id="password"
                                                  label="Password"
                                                  name="password"
                                                  type="password"
                                                  v-model="params.pass"
                                                  solo></v-text-field>
                                </v-form>
                            </v-card-text>
                            <div align="center">
                                <v-btn color="grey darken-1"
                                       @click="doLogin()"
                                       style="color:white;text-transform: none;width:120px;font-size:15px;">
                                    Login
                                </v-btn>
                            </div>
                        </div>
                    </v-layout>
                </v-container>
            </v-content>
        </v-app>
    </div>
</template>


<script>

    import axios from 'axios';

    //import Vue from 'vue'
    //import MyLogin from '../components/MyLogin';

    export default {
        //components: {MyLogin},
        data: () => ({
            version: g_version,
            info: "大丸松坂屋様納品代行システム",
            params: {
                name: "",
                pass: "",
            },
            error: "",
            isSuccess: false,
            isError: false,
        }),


        /*
         * 関数を登録する
         */
        methods: {

            /*
             * ベーシック認証を非同期で行う
             * @param name ユーザー名
             * @param pass パスワード
             */
            async doLogin() {
                try {
                    let params = new URLSearchParams();
                    params.append("param", JSON.stringify(this.params));
                    let response = await axios.post("/api/BasicLogin/Login", params);

                    this.isSuccess = response.data.Status === "OK";
                    this.isError = !this.isSuccess;
                    if (this.isError) {
                        return;
                    }

                    /*
                     * 検索画面へ遷移
                     */

                    console.log(response.data);

                    this.setCookie("Token", response.data.Token);
                    this.setCookie("UserName", response.data.UserName);

                    //console.log(this.getCookie("Token"));
                    window.location.href = "/search";
                }
                // エラーをキャッチしたとき
                catch (error) {
                    this.error = error;
                    this.isSuccess = false;
                    this.isError = true;
                }
            }
        }
    }
</script>

<style>
    .title-container {
        background-color: #EEEEEE;
        width: 400px;
        box-shadow: 0 2px 5px 0 rgb(0 0 0 / 16%), 0 2px 10px 0 rgb(0 0 0 / 12%);
    }
    .custom-placeholer-color input,
    .custom-label-color input{
      color: red!important;
    }
    .v-card {
        width: 600px;
    }

    .v-btn {
        margin-bottom: 15px;
    }
</style>